// extracted by mini-css-extract-plugin
export default {"modal":"rating-comments_modal__LQDZf","comment":"rating-comments_comment__Ec2jQ"};